/**
 * SiteFooter — global footer for SPA surfaces. Carries the legally-required
 * Privacy Policy and Terms of Service links plus the CritWise wordmark and
 * copyright line. Internal links use the app's client-side navigate so they
 * don't full-reload; falls back to a plain anchor when navigate is absent.
 *
 * Mirrors the marketing EJS footer (src/server/views/partials/footer.ejs) so
 * the two surfaces stay visually consistent. British English throughout.
 */
export function SiteFooter({ navigate = null }) {
  const go = (path) => (e) => {
    if (navigate) {
      e.preventDefault();
      navigate(path);
    }
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <span className="site-footer-wordmark">CRITWISE</span>
          <span className="site-footer-tagline">
            Schedule intelligence for Saudi mega-projects.
          </span>
        </div>
        <nav className="site-footer-nav" aria-label="Footer">
          <a href="/" onClick={go('/')}>Home</a>
          <a href="/privacy" onClick={go('/privacy')}>Privacy Policy</a>
          <a href="/terms" onClick={go('/terms')}>Terms of Service</a>
        </nav>
        <div className="site-footer-meta">
          © {new Date().getFullYear()} CritWise · critwise.com
        </div>
      </div>
    </footer>
  );
}
